const SIMPLE_ANALYTICS_SRC = 'https://scripts.simpleanalyticscdn.com/latest.js'

export function shouldLoadSimpleAnalytics(pathname: string): boolean {
  // The final segment authorises reading and writing a candidate's documents.
  // Redacting after analytics loads is too late: the initial page view already
  // contains the URL, so candidate routes must never load it at all.
  return !pathname.startsWith('/candidate/')
}

export function loadSimpleAnalytics(): void {
  if (!shouldLoadSimpleAnalytics(window.location.pathname)) return
  if (document.querySelector(`script[src="${SIMPLE_ANALYTICS_SRC}"]`)) return

  const script = document.createElement('script')
  script.async = true
  script.src = SIMPLE_ANALYTICS_SRC
  document.head.appendChild(script)
}
